// extracted by mini-css-extract-plugin
export var aircallIframe = "_j1-3";
export var fabContainer = "_j1-5";
export var fabRinging = "_j1-6";
export var loadingOverlay = "_j1-4";
export var pulse = "_j1-7";
export var widgetContent = "_j1-2";
export var widgetPanel = "_j1-0";
export var widgetPanelExpanded = "_j1-1";